import { Injectable } from '@angular/core';
import { CandidateSearchFilter } from './models/candidate-search-filter.model';

@Injectable({
    providedIn: 'root'
})
export class CandidateSearchService {
    createFilter(searchText: string): CandidateSearchFilter {
        const wordRegex = /^[a-zA-Z0-9.'@_-]+$/;
        const phoneRegex = /^[-()0-9]+$/;
        const tokens = searchText?.trim()?.split(/\s+/);

        if (tokens) {
            if (tokens.length === 1) {
                // single-token phone
                if (phoneRegex.test(tokens[0])) {
                    return {
                        phone: tokens[0] //,
                        //candidateId: tokens[0]
                    };
                }

                // token is first name, last name OR email
                if (wordRegex.test(tokens[0])) {
                    return { tokens };
                }
            }

            if (tokens.length > 1) {
                // token is multi-part phone
                if (tokens.every((token) => phoneRegex.test(token))) {
                    return {
                        phone: searchText
                    };
                }

                // tokens are chunks of first AND last names
                if (tokens.every((token) => wordRegex.test(token))) {
                    return { tokens };
                }
            }
        }

        return null;
    }
}
